// ============================================================
// Mock data — chat continuo con Lizzi
// ============================================================
export const MOCK_CHAT_THREADS = [
  { id:'th1', title:'Análisis SANDETEL Lote 2',         bid:'sandetel-25-00158',   updated:'Hace 2 horas',  pinned:true },
  { id:'th2', title:'Tarifario · escenario base 12,4%', bid:'sandetel-25-00158',   updated:'Hace 4 horas',  pinned:true },
  { id:'th3', title:'Comparar Andalucía Emprende vs SANDETEL', bid:'sandetel-25-00158', updated:'Ayer',   pinned:false },
  { id:'th4', title:'Borrador epígrafe 3.2 — despliegue territorial', bid:'min-igualdad-2026', updated:'Ayer', pinned:false },
  { id:'th5', title:'Riesgos típicos en programas FEDER', bid:'feder-2025',         updated:'Hace 3 días', pinned:false },
  { id:'th6', title:'Equipo mínimo para Mº Igualdad',    bid:'min-igualdad-2026',   updated:'Hace 5 días', pinned:false },
];

export const MOCK_CHAT_MESSAGES = [
  { role:'user',  content:'Resúmeme el caso SANDETEL Lote 2 en una frase y dime cuál es el principal riesgo del go/no-go.', at:'10:24' },
  { role:'lizzi', content:'Programa marco de aceleración digital de 1,87 M€ (12 m + 2 prórrogas), con presupuesto máximo no garantizado y un umbral técnico de 30/50 puntos en el Sobre 2. El principal riesgo de go/no-go es la **infraejecución del compromiso de 60 startups en plataforma de inversión**: la escala 60-90 hace que pasar de 66 a 90 startups suponga +36% de captación para ganar solo 4 puntos.', at:'10:24',
    blocks:[
      { kind:'callout', tone:'warning', icon:'AlertTriangle', text:'La acumulación máxima teórica de penalizaciones (ANS4-8) llega hasta 83.000 €. Hay que dimensionar la oferta económica con holgura.' }
    ]
  },
  { role:'user',  content:'¿Qué memoria previa nuestra encaja mejor para el epígrafe 3 (metodología)?', at:'10:27' },
  { role:'lizzi', content:'Tres candidatas — ordenadas por rúbrica de 25 puntos:', at:'10:27',
    blocks:[
      { kind:'table', headers:['Memoria','Encaje','Detalle','Coherencia','Total'],
        rows:[
          ['Programa Andalucía Emprende 2024','9/10','8/10','9/10','23 / 25'],
          ['Acelera PYME Madrid 2024',         '8/10','8/10','7/10','20 / 25'],
          ['Boost-up Cantabria 2023',          '7/10','7/10','7/10','18 / 25'],
        ] },
      { kind:'text', text:'Recomiendo partir de la memoria Andalucía Emprende (estructura 3-pilares · 9 epígrafes), adaptando el bloque 3.2 al despliegue territorial específico de SANDETEL.' }
    ]
  },
  { role:'user',  content:'Insértalo en el epígrafe 3.1 de la memoria abierta.', at:'10:29' },
  { role:'lizzi', content:'Insertado en §3.1 (2.400 palabras). Marcado como **borrador**, con badges de fuente. Pendiente de validación humana.', at:'10:29',
    blocks:[
      { kind:'actions', items:[
        { icon:'FileText',label:'Abrir §3.1' },
        { icon:'GitBranch',label:'Comparar versiones' },
        { icon:'Eye', label:'Ver diff' }
      ]}
    ]
  },
];
